module.exports = __webpack_public_path__ + "media/images/flags/64/Spain-0d442dcfcb849b71f56802040d9dc459.png";